import { Navigate } from 'react-router-dom';
import HomePage from '../../features/home/HomePage';
import { useExperienceProfile } from '../../features/home/useExperienceProfile';

/** Universal home: everyone lands on the home page (Build Contract §1D). */
export function ContributorHomeRedirect() {
  return <Navigate to="/prioritization/dashboard" replace />;
}

/**
 * The home for every member inside the app shell: the questions a person
 * walks in with, answered in order (roadmap E-7). It replaced the page of
 * widgets on 2026-10-13 (DEP-030).
 */
export function ContributorAwareDashboard() {
  // Sign-in always lands here (Login maps `/` to this address). A guided
  // member belongs on the bare home at `/`, so send them there once their
  // profile is known; everyone else sees the full home straight away.
  const profile = useExperienceProfile();
  if (profile === 'guided') return <Navigate to="/" replace />;
  return <HomePage profile="full" />;
}
